import { PayloadLink } from "@/components/shared/PayloadLink";
import type { NavItemConfig } from "@/lib/navigation-utils";

interface MegaMenuLinksProps {
  items: NonNullable<NavItemConfig["children"]> | NavItemConfig["children"];
  onNavigate?: () => void;
}

export function MegaMenuLinks({ items, onNavigate }: MegaMenuLinksProps) {
  if (!items || items.length === 0) {
    return (
      <div className="p-6 text-center text-gray-500">
        No links configured. Please add dropdown items in the CMS.
      </div>
    );
  }

  // Determine grid columns based on item count
  const gridCols = items.length <= 4 ? "grid-cols-2" : "grid-cols-3";

  return (
    <div className="p-6">
      <div className={`grid ${gridCols} gap-2`}>
        {items.map((item) => (
          <PayloadLink
            key={item.id}
            type={item.type}
            page={item.page}
            url={item.url}
            newTab={item.newTab}
            onClick={onNavigate}
            className="block px-4 py-3 rounded-lg hover:bg-gray-200 transition-colors group"
          >
            <span className="font-semibold text-gray-900 group-hover:text-brand transition-colors">
              {item.label}
            </span>
          </PayloadLink>
        ))}
      </div>
    </div>
  );
}
